<template>

    <div class="kalem">
    <imagefiledialog ref="imagefiledialog"></imagefiledialog>
    <loadingcomp mesaj="Fiş" v-model="loadingStatus"></loadingcomp>




            <v-layout row wrap>

                <v-flex xs12 md12 sm12>
                    <v-layout row wrap>
                        <yetkidialog ref="yetkidialog"></yetkidialog>
                         <v-toolbar class="baslik" size="120px" dark color="info">
                            <v-toolbar-title class="baslikfont"> {{ mainTitle }}  </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <a target="_self" v-bind:href="'#/coper/saticilar/islem/id?isl=yeni&tip=14'">
                                <v-btn flat> <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Insurance')}) }} </span>
                                <v-icon right dark>add_box</v-icon>
                                </v-btn>
                            </a>
                        </v-toolbar>
                     
                      
                        <div class="d-flex flex-row mb-6 bg-surface-variant">
      <v-sheet class="ma-2 pa-2"> <v-checkbox
    @change="komisyonChanged"
      v-model="komisyonGoster"
      :label="$t('Show-Commission')"
    ></v-checkbox></v-sheet>
      <v-sheet class="ma-2 pa-2"> <v-checkbox
    @change="gosterCariChanged"
      v-model="cariGoster"
      :label="$t('Show-Current-Account')"
    ></v-checkbox></v-sheet>
      <v-sheet class="ma-2 pa-2">  <v-checkbox
    @change="komisyonAciklamaChanged"
      v-model="komisyonAciklamaGoster"
      :label="$t('Show-Commission-Included-Excluded-Desc')"
    ></v-checkbox></v-sheet>
    </div>
                     
    

                        
               
                       
    
        
                       
                        <v-flex xs12 sm12 md12>
                            <span class=" font-weight-regular grey--text title"></span>
                            <v-divider></v-divider>
                        </v-flex>

             
                        <v-flex v-if="vouchergoster>0" xs10 pa-3 sm10 md10>
                         <v-card class="pa-3">


                            <div id="printJS-form">
                                <table style="page-break-after: always;" v-for="item in voucheritems.Sayfalar"
                                    :key="item.id" width="100%">
                                    <thead class="print">
                                        <tr>
                                            <td colspan="8">
                                            <table width="100%">
                                                <tr
                                                colspan="8"
                                                align="center"
                                                style="
                                                    padding-top: 20px;
                                                    padding-bottom: 20px;
                                                "
                                                >
                                                <td
                                                    align="left"
                                                    style="
                                                    width: 100%;
                                                    vertical-align: top;
                                                    padding-top: 10px;
                                                    padding-bottom: 10px;
                                                    "
                                                    id="imgUst"
                                                ></td>
                                                </tr>
                                            </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td bgcolor="grey" colspan="10" align=center
                                                style="padding-top:10px;padding-bottom:10px;">
                                                <span class=" white--text title">{{ mainTitle }}</span>
                                            </td>
                                        </tr>
                                        <br />
                                        <tr align=left>
                                            <td align="left" style="width:35%">
                                                <span class=".subtitle-2 font-weight-bold"> {{item.Satici.Isim}}</span>
                                            </td>

                                            <td style="width:60%">

                                            </td>

                                            <td style="width:35%">
                                                {{$t('Date')}}:
                                            </td>

                                            <td style="width:15%" align=left>
                                                {{getDateNow() | dateformat}}
                                            </td>

                                        </tr>

                                        <tr>
                                            <td>
                                                {{item.Satici.Yer}} &nbsp;
                                                {{item.Satici.Ulke}}
                                            </td>
                                            <td>

                                            </td>
                                            <td>
                                                {{$t('Hour')}} :
                                            </td>
                                            <td>
                                                {{getdatetimenow()}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ $t('Telephone') }}: {{item.Satici.Tel1}}
                                            </td>
                                            <td>

                                            </td>
                                            <td>
                                                 {{ $t('Bill-No') }} :
                                            </td>
                                            <td>
                                                {{item.RaporNo}}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                {{ $t('Telephone') }}2: {{item.Satici.Tel2}}
                                            </td>
                                            <td>
                                             
                                            </td>
                                            <td>
                                              {{ $t('Reservation-Made-By') }} :
                                            </td>
                                            <td>
                                             {{ item.RezervasyonYapan.Isim }} 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ $t('Hotel-Email') }}: {{item.Satici.Email}}
                                            </td>
                                            <td>

                                            </td>
                                            <td>
                                              E-Mail :
                                            </td>
                                            <td>
                                             {{ item.RezervasyonYapan.EMail }} 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-top:30px;" colspan="10">
                                                <table width="100%">
                                                    <tr bgcolor="grey" colspan="10" align=center>
                                                        <td style="margin-top:20px;width:5%;">
                                                            <span class=" white--text subheading">  {{ $t('Room-No') }} </span>
                                                        </td>

                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> {{ $t('PNR-No') }}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> {{ $t('Person-Type-Abbr') }}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> {{ $t('Quota-Abbr') }}</span>
                                                        </td>
                                                        <td style="width:20%">
                                                            <span class=" white--text subheading"> {{ $t('Name') }} </span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class=" white--text subheading">  {{ $t('Entry-Departure-Date') }} </span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> {{ $t('night') }}  </span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> Pax</span>
                                                        </td>

                                                        <td style="width:10%">
                                                            <span class=" white--text subheading"> {{ $t('Board-Type') }}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading">{{$t('Room-Type')}} </span>
                                                        </td>



                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td colspan="10">
                                                <table v-for="itemoda in item.Odalar" :key="itemoda.Sira" width="100%">

                                                    <tr align=center v-for="itemkisi in itemoda.Kisiler"
                                                        :key="itemkisi.adsoyad"
                                                        style="padding-top:10px;padding-bottom:10px;">


                                                        <td style="width:5%">
                                                            <span class="body-1">
                                                                {{itemoda.Sira}}
                                                            </span>
                                                        </td>

                                                        <td style="width:5%">
                                                            <span class="  body-1"> {{pnr}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{KisiTipToStr(itemkisi.kisiTip)}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{kontStr(itemoda.Kalem.kalemOtel.kontenjan)}}</span>
                                                        </td>
                                                        <td style="width:20%">
                                                            <span class="body-1"> {{itemkisi.adSoyad}}</span>
                                                            <span
                                                                class="caption red--text"><br>({{odeyenTarafGetir(itemoda.Kalem.odeyenTaraf)}})</span>

                                                        </td>
                                                        <td style="width:15%">
                                                            <span class="body-1">
                                                                {{itemoda.Kalem.donem1 | dateformat}}/{{itemoda.Kalem.donem2| dateformat}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{gunhesapla(itemoda.Kalem)}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{itemkisi.Pax}}</span>
                                                        </td>

                                                        <td style="width:10%">
                                                            <span class="  body-1">
                                                                {{PansiyonTipToStr(itemoda.Kalem.kalemOtel.pansiyon)}}</span>
                                                        </td>

                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{itemoda.Kalem.kalemOtel.odaTipi.kod}}
                                                            </span>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td colspan="10">
                                                            <v-divider></v-divider>
                                                        </td>
                                                    </tr>
                                                </table>

                                            </td>
                                        </tr>

                                        <tr>
                                            <td colspan="10">
                                                <table align="left" width="100%">
                                                    <tr align=left style="padding-top:15px;padding-bottom:15px;">
                                                      <td style="width:20%" v-if="cariGoster==true">
                                                            <span class="  subheading"> {{ $t('Current-Account') }} :
                                                                {{item.CariHesap.isim}}</span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class="  subheading"> {{ $t('Total-Pax') }} :
                                                                {{item.ToplamPax}}</span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class=" subheading"> {{ $t('Total-Room') }} :
                                                                {{odaSayisiGetir(item)}}</span>
                                                        </td>
                                                        <td>
                                                            <span class="  subheading">{{ $t('Room-Counts') }} </span>
                                                        </td>
                                                        <td v-for="itemodasayi in item.OdaToplamlari"
                                                            :key="itemodasayi.id">
                                                            <span class=" subheading"> {{itemodasayi.OdaKodu}} :
                                                                {{itemodasayi.Adet}} </span>
                                                        </td>
                                                    </tr>
                                                    <tr align=left style="padding-top:20px;padding-bottom:20px;">

                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>

                                        <br />
                                        <tr style="padding-top:30px;padding-bottom:30px;">
                                            <td colspan="10">
                                                <table border="1" style="border-collapse: collapse;" width="100%">


                                                    <tr align="center" style="padding-top:30px;padding-bottom:30px;">
                                                        <td rowspan="2" style="width:10%">
                                                            <span class=" black--text subheading"> {{ $t('Board-Abbr') }}</span>
                                                        </td>
                                                        <td rowspan="2" style="width:20%">
                                                            <span class=" black--text subheading"> {{ $t('Room-Type') }} </span>
                                                        </td>
                                                        <td rowspan="2" style="width:5%">
                                                            <span class=" black--text subheading"> {{ $t('Location') }} </span>
                                                        </td>
                                                        <td rowspan="2" style="width:5%">
                                                            <span class=" black--text subheading"> Pax</span>
                                                        </td>
                                                        <td v-if="komisyonGoster == true" rowspan="2" style="width:10%">
                                                            <span class=" black--text subheading"> {{ $t('Commission') }} </span>
                                                        </td>
                                                        <td rowspan="2" style="width:10%">
                                                            <span class=" black--text subheading">  {{ $t('Unit-Price') }} </span>
                                                        </td>
                                                        <td v-if="komisyonAciklamaGoster==true" colspan="4" style="width:40%">
                                                            <span class=" black--text subheading"> {{ $t('Included-in-Commission') }}  /
                                                                {{ $t('Excluding') }}</span>
                                                        </td>
                                                    </tr>

                                                    <tr align=center style="padding-top:20px;padding-bottom:20px;">


                                                        <td style="width:10%">
                                                            <span class=" black--text subheading"> {{ $t('VAT') }}</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class=" black--text subheading">{{ $t('Breakfast') }}</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class=" black--text subheading">{{ $t('Lunch') }} </span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class=" black--text subheading">{{ $t('Dinner') }} </span>
                                                        </td>
                                                    </tr>

                                                    <tr v-for="odeme in item.Fiyatlar" :key="odeme.id" align=center
                                                        style="padding-top:20px;padding-bottom:20px;">
                                                        <td style="width:5%">
                                                            <span class="  body-1">
                                                                {{PansiyonTipToStr(odeme.Pansiyon)}}</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class="  body-1"> {{odeme.OdaTipi.kod}}

                                                            </span><br> <span
                                                                class="caption red--text">({{odeyenTarafGetir(odeme.OdeyenTaraf)}})</span>
                                                        </td>
                                                        <td>{{odeme.Konum}}</td>
                                                        <td>{{odeme.Pax}}</td>
                                                        <td v-if="komisyonGoster == true">{{odeme.Komisyon | moneyformat}} {{odeme.KomisyonPara}}</td>
                                                        <td>{{odeme.BirimFiyat | moneyformat}} {{odeme.FiyatPara}}</td>
                                                        <td>{{truefalseStr(odeme.KDH_KDV)}} </td>
                                                        <td>{{truefalseStr(odeme.KDH_Kahvalti)}} </td>
                                                        <td>{{truefalseStr(odeme.KDH_OglenYemegi)}} </td>
                                                        <td>{{truefalseStr(odeme.KDH_AksamYemegi)}} </td>
                                                    </tr>

                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="11">
                                                {{Aciklamalar.Not}}
                                            </td>
                                        </tr>


                                        <br />

                                        <br />
                                        <br />
                                        <br />
                                        <br />

                                        <tr style="padding-top:20px;margin-top:10px;">

                                            <td colspan="4">
                                                <table width="100%">
                                                    <tr>
                                                        <td style="padding-top:60px;margin-top:60px;">
                                                            {{voucheritems.SirketBilgileri.SirketIsmi}}
                                                        </td>
                                                        <td>
                                                            {{$t('Person-Offering-Booking')}}
                                                        </td>
                                                        <td>
                                                            {{  $t('Approval')}}
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketAdres1}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketAdres2}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketTelefon}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketFaks}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{$t('Email_label')}}
                                                        </td>
                                                    </tr>

                                                </table>
                                            <td>

                                            </td>

                                        </tr>

                                        <tr>
                                            <td colspan="10">
                                                <span class="grey--text caption"> {{getDateNow() | dateformat}}
                                                    {{getdatetimenow()}}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                        <td colspan="10">
                                        <div id="imgAlt"></div>
                                        </td>
                                    </tr>

                                    </thead>

                                </table>
                            </div>

                         </v-card>


                        </v-flex>

                        <v-flex pa-3 xs2 sm2 md2>
                            <v-card class="pa-3">
                            <v-layout justify-center row wrap>
                                <!-- <v-btn @click="voucheryazdir()" color="info" outline>
                                    <v-icon small>print</v-icon> {{ $t('Print') }}
                                </v-btn> -->
                        <v-flex xs12 sm12 md12>
                        <v-btn
                          block
                          color="info"
                          outline
                          @click="LogoKaydet('Üst Logo Seçiniz', 'UstLogo')"
                        >
                          {{ $t('Upper-Logo') }} <v-icon right small>save</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-btn
                          block
                          color="info"
                          @click="LogoKaydet('Alt Logo Seçiniz', 'AltLogo')"
                          outline
                        >
                          {{ $t('Lower-Logo') }} <v-icon right small>save</v-icon>
                        </v-btn>
                      </v-flex>
                        <v-flex xs12 sm12 md12>
                                <v-btn @click="denemeyazdir('printJS-form')" block color="info" outline>
                                    <v-icon small>print</v-icon> {{ $t('Print') }}
                                </v-btn>
                        </v-flex>
                        
                                          <v-flex xs12 sm12>
  <v-btn block color="info" outline @click="EmailGonderPdf">
    {{ $t('Send-Mail') }} <v-icon right small>email</v-icon>
  </v-btn>
</v-flex>

<v-flex xs12 sm12 md12>
  <v-btn
    block
    color="info"
    outline
    @click="openReceiptPdfDialog"
  >
    {{ $t('Download-PDF') || 'PDF İndir' }}
    <v-icon right small>picture_as_pdf</v-icon>
  </v-btn>
</v-flex>




                            </v-layout>
                          </v-card>

                        </v-flex>


                    </v-layout>

                </v-flex>
<v-dialog v-model="emailDialog" max-width="560px" persistent>
  <v-card>
    <v-card-title class="headline">{{ $t('Send-Mail') }}</v-card-title>

    <v-card-text>
      <!-- VALIDASYON için v-form -->
      <v-form ref="emailForm" v-model="emailValid" lazy-validation>
        <v-text-field
          v-model="form.pnrNo"
          :label="$t('PNR-No')"
          :rules="[rules.required]"
          required
          clearable
        />
        <v-text-field
          v-model="form.to"
          :label="$t('Recipient-Email')"
          :rules="[rules.required, rules.email]"
          required
          clearable
        />
        <v-text-field
          v-model="form.agencyName"
          :label="$t('Agency-Name')"
          :rules="[rules.required]"
          required
          clearable
        />
        <v-text-field
          v-model="form.agentFullName"
          :label="$t('Agent-Full-Name')"
          :rules="[rules.required]"
          required
          clearable
        />
        <v-select
          v-model="form.docType"
          :items="docTypeItemsTranslated"
          :label="$t('Document-Type')"
          :rules="[rules.required]"
          required
          clearable
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="emailDialog=false">{{ $t('Cancel') }}</v-btn>
      <v-btn color="info"
             :disabled="!emailValid || submitting"
             :loading="submitting"
             @click="submitEmail">
        {{ $t('Send') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<!-- Rezervasyon Fişi PDF indirme popupu -->
<v-dialog v-model="receiptPdfDialog" max-width="420px" persistent>
  <v-card>
    <v-card-title class="headline">
      {{ $t('Download-PDF') || 'PDF İndir' }}
    </v-card-title>

    <v-card-text>
      <v-form ref="receiptPdfForm" v-model="receiptPdfValid" lazy-validation>
        <v-text-field
          v-model="receiptPdf.pnrNo"
          :label="$t('PNR-No') || 'PNR No'"
          :rules="[rules.required]"
          required
          clearable
        />

        <v-select
          v-model="receiptPdf.lang"
          :items="receiptPdfLangItems"
          item-text="text"
          item-value="value"
          :label="$t('Language-select') || 'Dil'"
          :rules="[rules.required]"
          required
          clearable
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="receiptPdfDialog=false">{{ $t('Cancel') || 'İptal' }}</v-btn>

      <v-btn
        color="info"
        :disabled="!receiptPdfValid || submittingReceiptPdf"
        :loading="submittingReceiptPdf"
        @click="submitReceiptPdfDownload"
      >
        {{ $t('Download') || 'İndir' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


            </v-layout>
        </v-card>
    </div>
</template>

<script>
import rez from "../../rezervasyon";
import printJS from "print-js";
import kur from "@/components/app/coper/comp/kur.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
import tarihcomp from "../../../customcomp/tarihim";
import parainput from "../../../customcomp/parainput";
import yuzdeinput from "../../../customcomp/yuzdeinput";
import helpers from "@/components/app/customcomp/helpers.js";
import tool from "../../tools";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import imagefiledialog from "@/components/app/coper/comp/imagefiledialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import auth from '@/api/auth'; 

export default {
  components: {
    kur,
    genelarama,
    genelaramakod,
    tarihcomp,
    geneltipara,
    parainput,
    yuzdeinput,
    yetkidialog,
    imagefiledialog,
    loadingcomp,
  },
  watch: {
    tumunusec(valsec) {
      if (valsec == true) {
        this.secilenkayitlar = this.val.Kisiler;
      } else {
        this.secilenkayitlar = [];
      }
    },
  },

  props: ["value"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    docTypeItemsTranslated() {
      return [
        { text: this.$t('Reservation-Receipt'), value: 'reservation' },
        { text: 'Voucher', value: 'voucher' }
      ];
    },
  },

  data() {
    return {
      receiptPdfDialog: false,
  receiptPdfValid: false,
  submittingReceiptPdf: false,

  receiptPdf: {
    pnrNo: '',
    lang: 'tr',
  },

  receiptPdfLangItems: [
    { text: 'Türkçe', value: 'tr' },
    { text: 'English', value: 'en' },
  ],

      emailDialog: false,
      submitting: false,
emailValid: false,
      form: {
        pnrNo: '',
        to: '',
        agencyName: '',
        agentFullName: '',
        docType: 'voucher'

      },
docTypeItems: [
        { text: 'Rezervasyon Fişi', value: 'reservation' },
        { text: 'Voucher', value: 'voucher' }
      ],
rules: {
        required: v => !!v || this.$t('This-Field-Is-Required'),
        email: v => /.+@.+\..+/.test(v) || this.$t('Enter-Valid-Email'),
        pnr: v => (v && String(v).length >= 3) || this.$t('Enter-Valid-PNR')
      },
      komisyonAciklamaGoster:true,
      cariGoster:true,
      komisyonGoster:false,
      loadingStatus: false,
      UstLogoUrl: null,
      AltLogoUrl: null,
      Aciklamalar: {
        Aciklama1: null,
        Aciklama2: null,
        Not: null,
      },
      pnr: null,
      vouchergoster: false,
      voucheritems: [],
      aractipitems: [],
      menu2: false,
      menu1: false,
      menualissati: false,
      menuteslimsati: false,
      menumusteslimsati: false,
      ucusnoitems: [],
      rehberdilitems: [],
      transfertipitems: [
        {
          text: this.$t('None'),
          value: "Yok",
        },
        {
          text: this.$t('Golf-course-tasks'),
          value: "Golf Sahası Yapacak",
        },
        {
          text: this.$t('Agency-tasks'),
          value: "Acenta Yapacak",
        },
      ],

      vizetipitems: rez.VizeTipi(),
      vizedurumuitems: rez.VizeDurumu(),
      vizegiristipiitems: rez.VizeGirisTipi(),
      mainTitle: null,
      tumunusec: false,
      secilenkayitlar: [],
      dialogShow: false,
      error: "",
      adresler: [],
      search: "",
      selected: [],
      odemeTipi: rez.OdemeTipi,

      tabmodel: "tab-genel",

      kisiSira: [],
      headers: [
        {
          text: "Isim",
          align: "left",
          value: "adSoyad",
          sortable: false,
        },
      ],
      menuItems: [
        {
          title: this.$t('Find-Price')
        },
        {
          title: this.$t('Calculate-Price')
        },
      ],
      Pansiyon: [
        {
          kod: 0, //"OB",
          aciklama: "Only Bed",
        },
        {
          kod: 1, //"BB",
          aciklama: "Bed & Breakfast",
        },
        {
          kod: 2, //"HB",
          aciklama: "Half Board",
        },
        {
          kod: 3, //"FB",
          aciklama: "Full Board",
        },
        {
          kod: 4, //"FF",
          aciklama: "FF",
        },
        {
          kod: 5, //"FC",
          aciklama: "FC",
        },
        {
          kod: 6, //"AI",
          aciklama: "All Inclusive",
        },
        {
          kod: 7, //"UAI",
          aciklama: "Ultra All Inclusive",
        },
      ],
    };
  },

  created() {},
  methods: {
openReceiptPdfDialog() {
    this.receiptPdf = {
      pnrNo: this.pnr || this.$route.query.PNR_No || "",
      lang: (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : "tr",
    };

    this.receiptPdfValid = false;

    this.$nextTick(() => {
      if (this.$refs.receiptPdfForm && this.$refs.receiptPdfForm.resetValidation) {
        this.$refs.receiptPdfForm.resetValidation();
      }
    });

    this.receiptPdfDialog = true;
  },

 

async submitReceiptPdfDownload() {
  this.submittingReceiptPdf = true;

  try {
    if (this.$refs.receiptPdfForm && this.$refs.receiptPdfForm.validate) {
      var result = await this.$refs.receiptPdfForm.validate();
      var isValid = (typeof result === "object") ? !!result.valid : !!result;
      if (!isValid) return;
    }

    var pnrNo = this.receiptPdf.pnrNo;
    var lang = this.receiptPdf.lang;

    var credentialsRaw = window.localStorage.getItem("credentials");
    var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : null;

    var url =
      auth.API_URL +
      "api/Coper/ReservationReceiptPdfDownload" +
      "?pnrNo=" + encodeURIComponent(pnrNo) +
      "&lang=" + encodeURIComponent(lang);

    var headers = {
      Authorization: "Bearer " + auth.getAuthHeader(),
    };

    if (credentials) {
      headers["CariSirketNo"] = credentials.SirketKodu.toString();
      headers["CoperSirketNo"] = credentials.CoperSirketNo.toString();
      headers["MuhasebeSirketNo"] = credentials.MuhasebeSirketNo.toString();
    }

    var response = await this.$http.post(
      url,
      {},
      {
        headers: headers,
        responseType: "arraybuffer",
      }
    );

    // PDF indir
    var blob = new Blob([response.data], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "ReservationReceipt_" + pnrNo + "_" + lang + ".pdf";
    link.click();
    URL.revokeObjectURL(link.href);

    this.receiptPdfDialog = false;

    if (this.$toast && this.$toast.success) {
      this.$toast.success(this.$t("Downloaded") || "PDF indirildi");
    }
  } catch (error) {
    console.error("Reservation Receipt PDF indirilemedi", error);

    this.text1 = this.$t
      ? this.$t("PDF-could-not-be-downloaded")
      : "PDF indirilemedi";
    this.snackbar = true;
  } finally {
    this.submittingReceiptPdf = false;
  }
},


  EmailGonderPdf() {
    
    this.form = {
      pnrNo: this.pnr,
      to: this.voucheritems.Sayfalar[0].Satici.Email,
      cc: '',
      agencyName: this.voucheritems.Sayfalar[0].Satici.Isim,
      agentFullName: '',
      docType: 'reservation',
    };
    this.emailValid = false;

    
    this.$nextTick(() => {
      if (this.$refs.emailForm && this.$refs.emailForm.resetValidation) {
        this.$refs.emailForm.resetValidation();
      }
    });

    
    this.emailDialog = true;
  },

  // Dialog içindeki "Gönder" butonu / form submit
  async submitEmail(force = true) {
    console.log('[submitEmail] click');
    this.submitting = true;

    try {
      if (!force && this.$refs.emailForm && this.$refs.emailForm.validate) {
        const result = await this.$refs.emailForm.validate();
        const isValid = typeof result === 'object' ? !!result.valid : !!result;
        if (!isValid) {
          console.warn('[submitEmail] form invalid -> gönderim iptal');
          return;
        }
      }

      // Backend'in beklediği payload
      const params = {
        pnrNo: this.form.pnrNo,
        to: this.form.to,
        cc: this.form.cc || null,
        agencyName: this.form.agencyName,
        agentFullName: this.form.agentFullName,
        docType: this.form.docType,
      };

      // API çağrısı
      const res = await tool.http_post(this, 'EmailGonderPdf', params);
      console.log('[submitEmail] OK', res);

      if (this.$toast && this.$toast.success) {
        this.$toast.success(this.$t('Email-Sent'));
      }

      this.emailDialog = false;
    } catch (err) {
      console.error('[submitEmail] ERROR', err);
      if (this.$toast && this.$toast.error) {
        this.$toast.error(this.$t('Error-During-Sending'));
      }
    } finally {
      this.submitting = false;
    }
  },



    truefalseStr(t) {
      if (t == true) {
        return this.$t('Excluded');
      } else {
        return this.$t('Included');
      }
    },
    kontStr(t) {
      if (t == true) {
        return this.$t('Yes');
      } else {
        return this.$t('No');
      }
    },
    PansiyonTipToStr(tip) {
      if (tip == null) {
        tip = 0;
      }

      var varmi = this.Pansiyon.filter(function (el) {
        return el.kod == tip;
      });
      if (varmi.length != 0) {
        return varmi[0].aciklama;
      } else {
        return null;
      }
    },
    getImages() {
      var params = {
        FileCode: "UstLogo",
      };

      tool.http_post(this, "BinaryFileLoadBase64", params).then((response) => {
        if (response.body.Status == true) {
          if (response.body.data.DosyaUzantisi == ".jpeg") {
            this.UstLogoUrl =
              "data:image/jpeg;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.UstLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".jpg") {
            this.UstLogoUrl =
              "data:image/jpg;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.UstLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".png") {
            this.UstLogoUrl =
              "data:image/png;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.UstLogoUrl);
          }
        }
      });

      var params1 = {
        FileCode: "AltLogo",
      };

      tool.http_post(this, "BinaryFileLoadBase64", params1).then((response) => {
        if (response.body.Status == true) {
          if (response.body.data.DosyaUzantisi == ".jpeg") {
            this.AltLogoUrl =
              "data:image/jpeg;base64," + response.body.data.imageBase64;
            this.addDownImage(this.AltLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".jpg") {
            this.AltLogoUrl =
              "data:image/jpg;base64," + response.body.data.imageBase64;
            this.addDownImage(this.AltLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".png") {
            this.AltLogoUrl =
              "data:image/png;base64," + response.body.data.imageBase64;
            this.addDownImage(this.AltLogoUrl);
          }
        }
      });
    },
    addUpImage(imageUrl) {
      if (this.UstLogoUrl != null) {
        var newImageUst = document.createElement("img");
        newImageUst.src = imageUrl;
        newImageUst.style = "width:1000px;height:200px;";
        document.getElementById("imgUst").innerHTML = "";
        document.getElementById("imgUst").appendChild(newImageUst);
      }
    },
    addDownImage(imageUrl) {
      if (this.AltLogoUrl != null) {
        var newImageAlt = document.createElement("img");
        newImageAlt.src = imageUrl;
        newImageAlt.style = "width:1000px;height:200px;";
        document.getElementById("imgAlt").innerHTML = "";
        document.getElementById("imgAlt").appendChild(newImageAlt);
      }
    },
    LogoKaydet(Title, FileCode) {
      this.$refs.imagefiledialog.open(Title, FileCode).then((confirm) => {
        if (confirm !== "") {
          this.otelrezfisYazdir(this.$route.query.PNR_No);
        }
      });
    },
    odaSayisiGetir(val) {
      var sum = val.OdaToplamlari.reduce(function (a, b) {
        return a + b.Adet;
      }, 0);
      return sum;
    },
    odeyenTarafGetir(val) {
      return rez.OdeyenTarafGetir(val);
    },
    getdatetimenow() {
      var timenow = helpers.getTimeNow();

      return String(timenow);
    },

    gunhesapla(val) {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(val.donem1);
      const secondDate = new Date(val.donem2);

      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

      return diffDays;
    },

    denemeyazdir(divName) {
      // var mywindow = window.open("", "PRINT", "height=500,width=700");

      // mywindow.document.write("</head><body >");
      // mywindow.document.write(document.getElementById(divName).innerHTML);
      // mywindow.document.write("</body></html>");

      // mywindow.document.close(); // necessary for IE >= 10
      // mywindow.focus(); // necessary for IE >= 10*/

      // mywindow.print();
      // mywindow.close();

      // return true;
            printJS({
        printable: "printJS-form",
        type: "html"
      });
    },
    voucheryazdir() {
      var prm = {
        printable: this.someJSONdata,
        properties: ["name", "email", "phone"],
        type: "json",
      };

      //'printJS-form', 'html'
      printJS("printJS-form", "html");
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    otelrezfisYazdir(val) {
      this.loadingStatus = true;

      var params = {
        PNR_No: val,
      };
      tool.http_post(this, "OtelRezFis", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.voucheritems = response.body.data;
            this.Aciklamalar = response.body.data.Aciklamalar;
            this.sleep(5000).then(() => {
              this.getImages();
              this.loadingStatus = false;
            });
            this.vouchergoster = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.vouchergoster = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.vouchergoster = false;
        }
      );
    },

    KisiTipToStr(tip) {
      return rez.KisiTipToStr(tip);
    },
    getDateNow() {
      return helpers.getDateNow();
    },
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    },
    setSelected(v) {
      this.selected = v;
    },
    setDialogShow(v) {
      this.dialogShow = v;
    },

    close() {
      this.value.dialogShow = false;
      setTimeout(() => {
        this.value.kalem = Object.assign({}, rez.Kalem());

        this.value.editedIndex = -1;
      }, 300);
    },

    modalOk() {
      this.value.kalem.kisiSira = [];
      for (var i = 0; i < this.selected.length; i++) {
        this.value.kalem.kisiSira.push(this.selected[i].kisiSira);
      }

      if (this.value.editedIndex > -1) {
        Object.assign(
          this.value.Rez.kalemler[this.value.editedIndex],
          this.value.kalem
        );
      } else {
        this.value.Rez.kalemler.push(this.value.kalem);
      }
      this.close();
    },
  },
  komisyonChanged()
  {
    this.otelrezfisYazdir(this.$route.query.PNR_No);
  },
  gosterCariChanged()
  {
    this.otelrezfisYazdir(this.$route.query.PNR_No);
  },
  komisyonAciklamaChanged()
  {
    this.otelrezfisYazdir(this.$route.query.PNR_No);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.pnr = this.$route.query.PNR_No;
      var rezType = this.$route.query.rezType;
      switch (rezType) {
        case "1":
          this.mainTitle = this.$t('Reservation-Receipt-Title');
          break;
        case "2":
          this.mainTitle = this.$t('Reservation-Cancellation-Receipt');
          break;
        case "3":
          this.mainTitle = this.$t('Reservation-Change-Receipt');
          break;
        default:
          break;
      }

      this.otelrezfisYazdir(this.$route.query.PNR_No);
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }
  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },

  moneyformat: function (m) {
    return helpers.moneyformat(m);
  },

  bakiyekontrol: function (m) {
    return helpers.bakiyekontrol(m);
  },
};
</script>
<style>
table {
  border-collapse: collapse;
}
</style>